import { Injectable } from '@angular/core';
import { CachedCRUDService } from '../types/cached-c-r-u-d.service';
import { TableKeyItemWithCode } from '../types/table';
import { DocumentTypeService } from './document-type.service';

@Injectable({
  providedIn: 'root',
})
export class PersonDocumentTypeService extends CachedCRUDService<TableKeyItemWithCode, never, never> {
  constructor(private documentTypeService: DocumentTypeService) {
    super();
    this.options.cacheExpiration = -1;
  }

  protected override async _fetchNewData(): Promise<TableKeyItemWithCode[]> {
    const types = await this.documentTypeService.getAll();
    const notAllowedDocumentCodes = ['NIT']
    const documents = types.filter((type) => !notAllowedDocumentCodes.includes(type.code));
    documents.forEach((doc) => {
      doc.description = this.formatName(doc.description);
    });
    documents.sort((a, b) =>
      a.description.toLowerCase().localeCompare(b.description.toLowerCase())
    );
    return documents.map((type) => {
      return {
        id: type.id,
        title: type.description,
        code: type.code,
      };
    });
  }
  protected override async _getByIdData(id: number): Promise<TableKeyItemWithCode | undefined> {
    const type = await this.documentTypeService.getById(id);
    if (type) {
      return {
        id: type.id,
        title: this.formatName(type.description),
        code: type.code,
      };
    }
    return undefined;
  }

  private formatName(name: string) {
    const firstLetter = name.charAt(0).toUpperCase();
    const content = name.slice(1).toLowerCase();

    return `${firstLetter}${content}`;
  }
}